import { useEffect, useState } from "react";
import u from "./ui.module.css";

function initials(name) {
  const parts = String(name || "?")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return (parts[0]?.[0] || "?").toUpperCase();
}

export default function Avatar({ name, src, size = "md", className = "" }) {
  const [imgFailed, setImgFailed] = useState(false);
  const [imgLoaded, setImgLoaded] = useState(false);
  const sizeClass =
    size === "lg" ? u.avatarLg : size === "sm" ? u.avatarSm : u.avatarMd;
  const photoSrc = String(src || "").trim();
  const showPhoto = Boolean(photoSrc) && !imgFailed;
  const showInitials = !showPhoto || !imgLoaded;

  useEffect(() => {
    setImgFailed(false);
    setImgLoaded(false);
  }, [photoSrc]);

  return (
    <div
      className={`${u.avatar} ${sizeClass} ${showPhoto ? u.avatarWithPhoto : ""} ${className}`}
      aria-hidden
    >
      {showInitials ? (
        <span className={u.avatarInitials}>{initials(name)}</span>
      ) : null}
      {showPhoto ? (
        <img
          src={photoSrc}
          alt=""
          className={u.avatarImg}
          onLoad={() => setImgLoaded(true)}
          onError={() => {
            setImgFailed(true);
            setImgLoaded(false);
          }}
        />
      ) : null}
    </div>
  );
}
